import { Platform } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

export const useIsSmallWebLayout = () => {
  const { isSmallLayout, isSmallTabletLayout } = useLayoutContext();
  return Platform.OS === 'web' && (isSmallLayout || isSmallTabletLayout);
};
